import React from 'react';

export interface PerformerLegendLabels {
	top: string;
	typical: string;
	bottom: string;
}

interface Props {
	color: string;
	labels: PerformerLegendLabels;
}

const ASTERISK_PATH =
	'M10.5978 2.53173 L6.98137 6.18131 L10.5978 9.83089 L9.46877 10.9467 L5.85234 7.29716 ' +
	'L2.23591 10.9467 L1.12695 9.83089 L4.74338 6.18131 L1.12695 2.53173 L2.23591 1.41553 ' +
	'L5.85234 5.06511 L9.46877 1.41553 Z ' +
	'M11.1408 6.78081 L6.85916 6.78081 L6.85916 11.0135 L4.84543 11.0135 L4.84543 6.78081 ' +
	'L0.563721 6.78081 L0.563721 4.78081 L4.84543 4.78081 L4.84543 0.548096 L6.85916 0.548096 ' +
	'L6.85916 4.78081 L11.1408 4.78081 Z';

const StarMarker = ({ color }: { color: string }) => (
	<svg width="14" height="14" viewBox="0 0 12 12" className="shrink-0" aria-hidden="true">
		<path d={ASTERISK_PATH} fill={color} strokeWidth="1" />
	</svg>
);

const CircleMarker = ({ color }: { color: string }) => (
	<svg width="14" height="14" viewBox="0 0 12 12" className="shrink-0" aria-hidden="true">
		<circle cx="6" cy="6" r="4.25" fill="transparent" stroke={color} strokeWidth="1.5" />
	</svg>
);

const CrossMarker = ({ color }: { color: string }) => (
	<svg width="14" height="14" viewBox="0 0 12 12" className="shrink-0" aria-hidden="true">
		<path
			d="M2 2 L10 10 M10 2 L2 10"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			fill="none"
		/>
	</svg>
);

const PerformerLegend = ({ color, labels }: Props) => {
	const legendItems = [
		{ label: labels.top, Marker: StarMarker },
		{ label: labels.typical, Marker: CircleMarker },
		{ label: labels.bottom, Marker: CrossMarker },
	];
	return (
		<div className="flex min-w-0 flex-wrap items-center justify-center gap-x-6 gap-y-1">
			{legendItems.map(({ label, Marker }) => (
				<span key={label} className="inline-flex items-center gap-2">
					<Marker color={color} />
					<span className="footnoteregular text-character-primary">{label}</span>
				</span>
			))}
		</div>
	);
};

export default PerformerLegend;
